<template>
  <transition
    name="toast-transition"
    enter-active-class="animated fadeInUp"
    leave-active-class="animated fadeOutDown"
  >
    <div
      v-if="!!message"
      class="toast-alert"
    >
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    message: {
      type: [String, Boolean],
      default: false
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.toast-alert {
  display: block;
  position: fixed;
  bottom: 20px;
  right: 20px;
  color: white;
  z-index: 999999;
  background-color: $grey-darkest;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: $border-radius-lg;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
}

/* Animation */

@keyframes fadeInUp {
  from {
    transform: translate3d(0, 40px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animatedFadeInUp {
  opacity: 0;
}

.fadeInUp {
  opacity: 0;
  animation-name: fadeInUp;
}

@keyframes fadeOutDown {
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}

.fadeOutDown {
  animation-name: fadeOutDown;
}
</style>
